import(/* webpackMode: "eager" */ "/home/das/web/crowdvault.digitas.my/nodeapp/src/app/investor-account/page.tsx");
